export default __webpack_public_path__ + "static/heroBg-dc905b4daeeab49bfc9632524e2d8ff9.png";